export const getSingleScreenConfigurationLabel = (screen: {
  width: number;
  height: number;
}) => {
  let screenSetup = '';

  if (screen.height > screen.width) {
    screenSetup = `Vertical`;
  } else if (screen.width > screen.height) {
    screenSetup = `Horizontal`;
  } else {
    screenSetup = 'No screen';
  }

  return screenSetup;
};
